<template>
    <div v-if="awards != null && awards.length > 0">
        <b class="d-block mb-2" v-if="displayBadges == true">Awards</b>
        <div class="award-badges row row-cols-4 row-cols-lg-3 ga-3" v-if="displayBadges == true">
            <div v-for="award, index in awards" :key="index">
                <img class="d-block img-fluid" :src="award.path" :alt="award.name + ' image'" />
            </div>
        </div>
        <div v-else>
            <div class="award-count bg-warning badge" v-if="awards.length > 0">
                <a :href="tyreUrl" class="text-black text-uppercase">
                    <p style="font-weight: 600;">{{ awards.length }} Award{{ awards.length != 1 ? 's' : ''}}</p>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['awards', 'tyreUrl', 'displayBadges']
    }
</script>